import { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse cx={9} cy={9.531} rx={9} ry={8.835} fill="#EE6002" />
    <path
      d="M5.226 14.376v-9.69h5.225l.233 1.14h3.251v5.7H9.871l-.233-1.14H6.387v3.99zm5.603-3.99h1.945v-3.42H9.726l-.233-1.14H6.387v3.42h4.21z"
      fill="#fff"
    />
  </svg>
);
export default SVGComponent;
